import { Helmet } from "react-helmet";

const FAQ_BY_CATEGORY = {
  laptops: [
    ["Скільки коштує чистка ноутбука?", "Звичайний ноутбук — від 700 грн, ігровий — від 1500 грн."],
    ["Скільки триває чистка ноутбука?", "У більшості випадків робота займає від однієї до трьох годин."],
  ],
  consoles: [
    ["Скільки коштує чистка консолі?", "Вартість залежить від моделі та стану консолі після діагностики."],
    ["Чи чистите ви PlayStation та Xbox?", "Так, обслуговуємо PS5, PS4 та Xbox Series X."],
  ],
  iphone: [
    ["Скільки триває ремонт iPhone?", "Заміна акумулятора або дисплея зазвичай виконується в день звернення."],
    ["Чи є гарантія на ремонт iPhone?", "Так, гарантія залежить від виду виконаної роботи."],
  ],
  pc: [
    ["Що входить у чистку ПК?", "Майстер очищує систему охолодження, замінює термоінтерфейси та тестує температури."],
    ["Коли потрібна чистка комп'ютера?", "Коли ПК шумить, перегрівається, гальмує або вимикається під навантаженням."],
  ],
  macbook: [
    ["Чи чистите ви MacBook Air і Pro?", "Так, обслуговуємо MacBook Air та MacBook Pro різних поколінь."],
    ["Чому MacBook перегрівається?", "Причиною часто є пил у системі охолодження та деградація термоінтерфейсу."],
  ],
};

export default function LandingFaqSchema({ category }) {
  const questions = FAQ_BY_CATEGORY[category] || [];

  if (!questions.length) {
    return null;
  }

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questions.map(([name, text]) => ({
      "@type": "Question",
      name,
      acceptedAnswer: {
        "@type": "Answer",
        text,
      },
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}